// Laden der Sonstige-Liste – gleiche Abfrage wie bisher in KontakteListe (quelle 'kontakt', Suche, nur Aktive).
// Zusätzlich (nur lesend): welche Kontakte Firmen sind – für das Wasserzeichen der Kachel (Handoff §1).
import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../supabase/client';
import { ladeKontakteUnified } from './api';
import type { KontaktUnified } from './types';

export type SonstigeListeZustand =
  | { status: 'laedt' }
  | { status: 'fehler'; meldung: string }
  | { status: 'ok'; kontakte: KontaktUnified[]; firmen: ReadonlySet<string> };

async function ladeFirmenIds(): Promise<Set<string>> {
  const { data } = await supabase.from('kontakte').select('id, firma_name').not('firma_name', 'is', null);
  const ids = new Set<string>();
  for (const z of (data ?? []) as { id: string; firma_name: string | null }[]) {
    if (z.firma_name?.trim()) ids.add(z.id);
  }
  return ids;
}

export function useSonstigeListe(suche: string, nurAktiv: boolean): { zustand: SonstigeListeZustand; neuLaden: () => void } {
  const [zustand, setZustand] = useState<SonstigeListeZustand>({ status: 'laedt' });
  const [runde, setRunde] = useState(0);

  useEffect(() => {
    let abbruch = false;
    setZustand({ status: 'laedt' });
    Promise.all([ladeKontakteUnified({ quelle: 'kontakt', suche, nurAktiv }), ladeFirmenIds()])
      .then(([kontakte, firmen]) => { if (!abbruch) setZustand({ status: 'ok', kontakte, firmen }); })
      .catch((err: unknown) => {
        if (!abbruch) setZustand({ status: 'fehler', meldung: err instanceof Error ? err.message : String((err as { message?: string })?.message ?? err) });
      });
    return () => { abbruch = true; };
  }, [suche, nurAktiv, runde]);

  const neuLaden = useCallback(() => setRunde(r => r + 1), []);
  return { zustand, neuLaden };
}
